import React from 'react';
import ResourceList from './resource-list';

const OrganizationList = (props) => (
    <ResourceList {...props} fields={["name", "email"]} labels={["Name", "Email"]} path="/organizations/" />
);

export default OrganizationList;

